import { useEventsQuery } from 'core/graphql/Itinerary/Events.generated';
import { ItineraryEvent } from 'core/graphql/types';

type ItineraryVersionsResult = {
  events: ItineraryEvent[];
  loadingEvents: boolean;
  refresh: () => Promise<void>;
};

const useEventsDataStore = (
  itineraryVersionId: string | undefined,
): ItineraryVersionsResult => {
  const { data, loading, refetch } = useEventsQuery({
    skip: !itineraryVersionId,
    variables: itineraryVersionId
      ? {
          itineraryVersionId,
        }
      : undefined,
  });

  const refresh = async () => {
    await refetch(
      itineraryVersionId
        ? {
            itineraryVersionId,
          }
        : undefined,
    );
  };

  if (data !== undefined) {
    return {
      events: data.Events,
      loadingEvents: loading,
      refresh,
    };
  }

  return {
    events: [],
    loadingEvents: loading,
    refresh,
  };
};

export default useEventsDataStore;
